module.exports = __webpack_public_path__ + "static/media/Bariol-Light.ee49bd51.woff2";